import { render } from "./userInfo.vue?vue&type=template&id=2a4d4835&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=2a4d4835&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a4d4835"

export default script